import {Action} from "redux-actions";
import Meta from "../_data/models/Meta";
import {
    clearSpecial,
    clearSpecials,
    didReceiveSpecial,
    didReceiveSpecials,
    requestFailed,
    requestStarted,
    requestSucceeded
} from "./actions";
import {combineReducers} from "redux";
import {Map, OrderedMap} from "immutable";

//reducers
const mySpecialsReducer = combineReducers({
    ids: items,
    meta,
    loading,
    errors
});
const specialReducer = combineReducers({
    item,
    loading,    
});

export {specialReducer};
export default mySpecialsReducer;

function loading(state: boolean = false, action: Action<SpecialAction>) {
    switch (action.type) {    
        case requestStarted.toString():
            return true;  
        case requestSucceeded.toString():
            return false;
    }
    return false;
}

function meta(state: Meta = null, action: Action<SpecialAction>) {
    switch (action.type) {
        case didReceiveSpecials.toString():
            return action.payload.meta;
    }
    return state;
}

function items(state: OrderedMap<number, number> = OrderedMap<number, number>(), action: Action<SpecialAction>) {      
    switch (action.type) {
        case clearSpecials.toString():
            return OrderedMap<number, number>();
        case didReceiveSpecials.toString():        
            return state.mergeDeep(Map<number, number>(action.payload.ids));                              
    }
    return state;
}

function item(state: number = null, action: Action<SpecialAction>) {   
    switch (action.type) {
        case clearSpecial.toString():
            return null;
        case didReceiveSpecial.toString():
            return action.payload.id;
    }
    return state;
}

function errors(state: string[] = [], action: Action<ApiRequestAction>) {
    switch (action.type){
        case requestStarted.toString():
            return [];
        case requestSucceeded.toString():
            return [];
        case requestFailed.toString():
            return action.payload.requestErrors
    }

    return state;
}

//interfaces
interface SpecialAction {
    id: number;
    ids: any;
    meta: Meta;
}


// WEBPACK FOOTER //
// ./app/client/special/reducers.ts